<template>
    <field-repeater
        ref="input.phone_numbers"
        v-model="items"
        :label="labelValue || null"
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :default-item="template"
        hide-remove-row
        :savable="savable"
        @save="$event => $emit('save', items)"
    >
        <template #row="row">
            <app-form-card
                v-model="items[`${row.index}`]"
                :readonly="row.disabled"
                :deleted="items[`${row.index}`].$deleted"
                class="flex-grow-1"
                :disable-remove-button="items.filter(i => !i.$deleted).length === 1 && required"
                @input:editing="items[`${row.index}`].$editing = $event"
                @input:remove="items[`${row.index}`].$deleted = true"
                @input:undo-remove="items[`${row.index}`].$deleted = false"
            >
                <field-phone-number
                    :ref="`input.phone_numbers[${row.index}]`"
                    v-model="items[`${row.index}`]"
                    :ref-prefix="`input.phone_numbers[${row.index}]`"
                    :disabled="row.disabled"
                    required
                    :require-label="requireLabel"
                />
            </app-form-card>
        </template>
    </field-repeater>
</template>

<script>
import BaseField from './BaseField';
import PhoneNumber from '@/models/PhoneNumber';
export default {
    name: 'PhoneNumbers',
    components: {
        FieldRepeater: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/Repeater'
            ),
        AppFormCard: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppFormCard'
            )
    },
    extends: BaseField,
    props: {
        savable: {
            type: Boolean,
            default: false
        },
        requireLabel: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        items: [],
        template: new PhoneNumber({ $editing: true })
    }),
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value && Array.isArray(value) && value !== this.items) {
                    this.items = value.map(item => (item instanceof PhoneNumber ? item : new PhoneNumber(item)));
                }
            }
        },
        items: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal || []);
            }
        }
    }
};
</script>
